module.exports = __webpack_public_path__ + "static/img/11.7e972fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/11.jpg
// module id = JlQF
// module chunks = 16